import { j as s } from "../../utils-BdNIfrGQ.js";
import { H as u } from "../../H2-CGvOaVnq.js";
import { P as d } from "../../Paragraph-Cpgi01iq.js";
import "../../Div-spVpsZsH.js";
import "../../Div.skeleton-DLnqOZrU.js";
import { F as n } from "../../Flex-BA9xHq_p.js";
import { S as h } from "../../Section-CJZfXZsR.js";
import "../../Grid-DJGISvmf.js";
import "react";
import { C as j } from "../../Cerbicon-CdMFPk5g.js";
import { a as g } from "../../Button-CzIiGCVn.js";
import { N as y } from "../../NavLink-D9Qfouy1.js";
import { E as v } from "../../ExternalLink-CwLUkrFF.js";
const R = ({ id: e, image: o, heading: l, description: m, actions: t, spacing: c }) => {
  const { alt: a, src: i, variant: x = "emptyState" } = o || {}, f = i && a;
  return /* @__PURE__ */ s.jsxs(h, { id: e, "data-testid": e, spacing: c, className: "max-w-[550px] mx-auto", children: [
    f && /* @__PURE__ */ s.jsx(n, { className: "justify-center", children: /* @__PURE__ */ s.jsx(j, { src: i, alt: a, variant: x }) }),
    /* @__PURE__ */ s.jsx(u, { align: "center", spacing: "4 0", children: l }),
    /* @__PURE__ */ s.jsx(d, { align: "center", children: m }),
    t && /* @__PURE__ */ s.jsx(n, { spacing: "6 0 5", gap: "4", className: "align-center justify-center flex-wrap", children: t.map((r, p) => {
      switch (r.type) {
        case "link":
          return /* @__PURE__ */ s.jsxs(y, { ...r.props, variant: "pill", children: [
            r.props.icon && r.props.icon,
            r.props.children
          ] }, p);
        case "externalLink":
          return /* @__PURE__ */ s.jsxs(v, { ...r.props, variant: "default", children: [
            r.props.children,
            r.props.icon && r.props.icon
          ] }, p);
        case "button":
          return /* @__PURE__ */ s.jsxs(g, { ...r.props, variant: "default", children: [
            r.props.icon,
            r.props.children
          ] }, p);
        /* v8 ignore start */
        default:
          return null;
      }
    }) })
  ] });
};
export {
  R as default
};
